"use client";
import { jsxs as q, jsx as a } from "react/jsx-runtime";
import { useState as f } from "react";
import { Close as A, Search as E } from "@videoblocks/react-icons";
import { MediaSelect as F } from "../../molecules/MediaSelect/MediaSelect.mjs";
import { MediaSelectContent as G } from "../../molecules/MediaSelect/MediaSelectContent.mjs";
import { MediaSelectItem as H } from "../../molecules/MediaSelect/MediaSelectItem.mjs";
import { Input as J } from "../../atoms/Input/Input.mjs";
import { IconButton as p } from "../../atoms/IconButton/IconButton.mjs";
import { cn as K } from "../../../utils/utils.mjs";
const ee = ({
  value: d,
  defaultValue: v,
  onChange: t,
  placeholder: x,
  autoFocus: k,
  "aria-label": g = "Search",
  onSubmit: o,
  onClose: S,
  showClose: V = !1,
  selectOptions: r,
  selectValue: n,
  defaultSelectValue: i,
  onSelectChange: c,
  submitAriaLabel: w = "Submit search",
  className: I,
  mediaSelectProps: N,
  ...y
}) => {
  var h, b;
  const [P, M] = f(v ?? ""), s = d !== void 0, u = s ? d : P, [j, z] = f(i), l = n !== void 0, m = l ? n : j, C = !!r && r.length > 0, D = ((h = r == null ? void 0 : r.find(({ value: e }) => e === m)) == null ? void 0 : h.placeholder) ?? x, L = (e) => {
    s || M(e.target.value), t == null || t(e);
  }, B = (e) => {
    l || z(e), c == null || c(e);
  };
  return /* @__PURE__ */ q(
    "form",
    {
      role: "search",
      onSubmit: (e) => {
        e.preventDefault(), o == null || o({ value: u, selectValue: m });
      },
      className: K("flex h-11 w-full items-center gap-3 rounded-[999px] bg-neutral-dark-200 px-1", I),
      children: [
        C && /* @__PURE__ */ a(
          F,
          {
            value: l ? n : void 0,
            defaultValue: l ? void 0 : i,
            onValueChange: B,
            placeholder: ((b = r[0]) == null ? void 0 : b.label) ?? "Select",
            className: "h-9 min-w-[90px] gap-2 bg-neutral-dark-100 px-3 py-2 text-sm text-white hover:border-transparent hover:bg-neutral-dark-200",
            ...N,
            children: /* @__PURE__ */ a(G, { children: r.map((e) => /* @__PURE__ */ a(
              H,
              {
                value: e.value,
                icon: e.icon,
                selectItemLabel: e.selectItemLabel,
                children: e.label
              },
              e.value
            )) })
          }
        ),
        /* @__PURE__ */ a(
          J,
          {
            type: "search",
            tone: "dark",
            value: u,
            onChange: L,
            placeholder: D,
            autoFocus: k,
            "aria-label": g,
            className: "h-10 flex-1 rounded-[999px] border-0 bg-neutral-dark-200 px-2 text-base font-normal text-neutral-dark-1000 placeholder:text-neutral-dark-700 focus:ring-0 focus:outline-none [&::-webkit-search-cancel-button]:hidden",
            ...y
          }
        ),
        V ? /* @__PURE__ */ a(
          p,
          {
            type: "button",
            variant: "secondary",
            size: "small",
            "aria-label": "Close search",
            onClick: S,
            icon: /* @__PURE__ */ a(A, { className: "fill-white" }),
            className: "bg-neutral-dark-100 hover:bg-neutral-dark-400"
          },
          "close"
        ) : /* @__PURE__ */ a(
          p,
          {
            type: "submit",
            variant: "secondary",
            size: "small",
            "aria-label": w,
            icon: /* @__PURE__ */ a(E, { className: "fill-white" }),
            className: "bg-neutral-dark-100 hover:bg-neutral-dark-400"
          },
          "submit"
        )
      ]
    }
  );
};
export {
  ee as ProminentSearch
};
